// extracted by mini-css-extract-plugin
export var amountPresets = "AmountPresets-module--amountPresets--c6f16";
export var presetButton = "AmountPresets-module--presetButton--ecaec";